import React, { useState } from "react";
import { useTranslation } from "utilities/i18n";
import { useDeleteMockRecordsMutation } from "generated/graphql";
import { DISMISS, useNotification } from "collections";
import { Card } from "collections/Cards";
import { SubmitButton } from "elements";

export const DeleteMockLicenses: React.FC<{
  tenantId: string;
}> = ({ tenantId }) => {
  const [processing, setProcessing] = useState<boolean>(false);
  const { t } = useTranslation();
  const [addNotification] = useNotification();
  const [, deleteMockRecords] = useDeleteMockRecordsMutation();

  const clickDeleteButton = async () => {
    setProcessing(true);
    const { error, data } = await deleteMockRecords({ tenantId });
    if (data?.deleteMockRecords.resultCode === "SUCCESS" && !error) {
      addNotification({
        type: "success",
        message: t("POLY_PLUS_MOCK_LICENSE_DELETION_SUCCESS"),
        dismiss: DISMISS.DEFAULT
      });
    }

    if (data?.deleteMockRecords.resultCode === "NO_MOCK_RECORDS_FOUND") {
      addNotification({
        type: "success",
        message: t("POLY_PLUS_MOCK_LICENSE_DELETION_NO_RECORDS_FOUND"),
        dismiss: DISMISS.DEFAULT
      });
    }

    setProcessing(false);
  };

  return (
    <Card className="table-card p-1">
      <div className="title">{t("POLY_PLUS_DELETE_MOCK_LICENSE_TITLE")}</div>
      <p>{t("POLY_PLUS_DELETE_MOCK_LICENSE_INFO")}</p>
      <div data-testid="poly-plus-delete-license">
        <SubmitButton
          className="btn"
          isSubmitting={processing}
          onClick={clickDeleteButton}
          labelKey="DELETE"
          submittingLabelKey="DELETING"
        />
      </div>
    </Card>
  );
};
